import { useSelector } from 'react-redux';

import { canEditCandidateProfile } from '../utils/permission';

// =============================================================================
// "Hồ sơ đang được sửa" - dùng THAY CHO state.profileReducer.profile ở toàn bộ
// cây Đăng ký hồ sơ QCV.
//
// Bình thường trả về profile của chính người đăng nhập (y như cũ). Chỉ khi
// quản trị viên tổng (super_admin) mở /dang-ky-ho-so/:profileId thì mới trả về
// profile của ứng viên đó.
//
// Hai lớp khoá, phải thoả CẢ HAI mới vào chế độ sửa hộ:
//   1. Redux có targetProfile (chỉ được set bởi adminEditingActions).
//   2. Người đăng nhập đúng là super_admin (CHỈ quản trị viên tổng; qcv_admin
//      KHÔNG được sửa hộ - xem canEditCandidateProfile).
// Lớp 2 để phòng trường hợp state cũ còn sót lại sau khi đổi tài khoản.
// =============================================================================

export const useIsAdminEditing = () => {
  const role = useSelector((state) => state.userReducer.user?.role);
  const targetProfile = useSelector((state) => state.adminEditingReducer.targetProfile);
  return !!targetProfile && canEditCandidateProfile(role);
};

// Profile đang được sửa (của ứng viên nếu đang sửa hộ, ngược lại của chính mình).
export const useEditingProfile = () => {
  const ownProfile = useSelector((state) => state.profileReducer.profile);
  const targetProfile = useSelector((state) => state.adminEditingReducer.targetProfile);
  const isAdminEditing = useIsAdminEditing();
  return isAdminEditing ? targetProfile : ownProfile;
};

export const useEditingProfileId = () => useEditingProfile()?.id;
